import { Input, Button } from '@/components/atoms';
import { SearchIcon, DownloadIcon, FilterIcon } from 'lucide-react';

interface SearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  placeholder?: string;
  showFilter?: boolean;
  showExport?: boolean;
  onFilter?: () => void;
  onExport?: () => void;
}

export const SearchBar = ({
  searchQuery,
  setSearchQuery,
  placeholder = 'Search...',
  showFilter = true,
  showExport = true,
  onFilter,
  onExport,
}: SearchBarProps) => {
  return (
    <div className="flex justify-between items-center gap-4">
      <div className="flex-1 max-w-md">
        <div className="flex items-center border border-input rounded-md overflow-hidden">
          <SearchIcon className="text-gray-400 w-4 h-4 shrink-0 ml-4" />
          <Input
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            borderless
            className="rounded-none"
          />
        </div>
      </div>
      <div className="flex items-center gap-2">
        {showFilter && (
          <Button variant="outline" size="sm" onClick={onFilter}>
            <FilterIcon className="w-4 h-4 mr-2" />
            Filter
          </Button>
        )}
        {showExport && (
          <Button variant="outline" size="sm" onClick={onExport}>
            <DownloadIcon className="w-4 h-4 mr-2" />
            Export CSV
          </Button>
        )}
      </div>
    </div>
  );
};
